import { useAuthorizedFeature } from 'hooks'
import { useCurrentAdminQuery, FeatureGrant, useCurrentUserQuery } from 'types'

export const useCanEditCoachProfile = () => {
  const { data: { currentUser } = {} } = useCurrentUserQuery()
  const { data: { currentAdmin } = {} } = useCurrentAdminQuery()
  const [isAuthorizedToEditCoachProfile, isAuthorizedToEditOwnCoachProfile] = useAuthorizedFeature([
    FeatureGrant.UsersEditCoachProfile,
    FeatureGrant.UsersEditOwnCoachProfile
  ])

  const isOwnProfile = currentAdmin?.id === currentUser?.id

  if (isOwnProfile) {
    return isAuthorizedToEditOwnCoachProfile
  }

  return isAuthorizedToEditCoachProfile
}
